module.exports = __webpack_public_path__ + "img/juice.37f466d7.svg";